<div class="users-sort">
    <label for="usersSort" class="form-label"><strong>{{localize(langSection.LocationUserPage, langText.SortUsersBy)}}</strong></label>
    <div class="sort-controls">
        <ups-select name="usersSort" [list]="sortOptions" [value]="selectedSort" (change)="updateUserSort($event.target.value)">
        </ups-select>
        <button aria-label="Ascending or Descending" class="up-and-down-sort btn" type="button" (click)="toggleAscending()"></button>
    </div>
</div>